import { Amplify } from 'aws-amplify';
import { getEnv } from './env';

let configured = false;

/**
 * Configure Amplify Auth v6 against the existing Cognito pool (created by CDK
 * in `infra/cdk/lib/stacks/core-stack.ts`). Called once from `main.tsx` before
 * any auth API is used.
 *
 * The pool has `authFlows: { userSrp: true }` enabled, so Amplify's default
 * `signIn()` (USER_SRP_AUTH) works without additional flags. MFA is REQUIRED
 * in prod with TOTP-only (`mfaSecondFactor: { sms: false, otp: true }`), so
 * `signIn()` will return `nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_TOTP_CODE'`
 * for enrolled users and `'CONTINUE_SIGN_IN_WITH_TOTP_SETUP'` for first-time.
 *
 * Tokens land in localStorage by default (Amplify's `CookieStorage` /
 * `defaultStorage`). `fetchAuthSession()` handles silent refresh against the
 * refresh token (30d validity).
 */
export function configureAmplify(): void {
  if (configured) return;
  const env = getEnv();
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: env.VITE_COGNITO_CLIENT_ID,
        signUpVerificationMethod: 'code',
        loginWith: { email: true },
        passwordFormat: {
          minLength: 12,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  });
  configured = true;
}
